export default __webpack_public_path__ + "static/media/icon-faxina.dcd2d0cb.svg";